class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper') || document.querySelector('.custom-header-wrapper');
    this.dropdown = this.querySelector('.mega-menu-dropdown');
    this.setupHoverBehavior();
  }

  setupHoverBehavior() {
    if (!this.dropdown) return;

    // Only set up hover behavior on desktop (mouse devices)
    if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      // Open on hover - CSS handles this but we set header position
      this.addEventListener('mouseenter', () => {
        if (this.header) {
          this.header.preventHide = true;
        }
        // Set header position for sticky header
        if (this.header && document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
          document.documentElement.style.setProperty(
            '--header-bottom-position-desktop',
            `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
          );
        }
      });

      // Close when mouse leaves
      this.addEventListener('mouseleave', () => {
        if (this.header) {
          this.header.preventHide = false;
        }
      });
    }
  }
}

customElements.define('header-menu', HeaderMenu);
